import { DateTime } from "luxon";
import { useEffect } from "react";

import RefreshModal from "../App/Layout/RefreshModal/RefreshModal";
import ModalModel from "../Models/Modal/Modal.Model";

export const useDailyReboot = () => {
  useEffect(() => {
    localStorage.setItem("lastDailyReboot", DateTime.now().toFormat("yyyy-MM-dd"));

    const interval = setInterval(() => {
      const now = DateTime.now();
      const hour = now.get("hour");
      const today = now.toFormat("yyyy-MM-dd");

      if (hour > 3 && today !== localStorage.getItem("lastDailyReboot")) {
        localStorage.setItem("lastDailyReboot", today);
        ModalModel.showModalWithContent(null, <RefreshModal />, 544, 544, false);
      }
    }, 1000 * 15);

    return () => clearInterval(interval);
  }, []);
};
